import { DownOutlined } from '@ant-design/icons';
import upperFirst from "lodash/upperFirst";
import { useI18n } from '@9troisquarts/wand';
import { Dropdown, Space } from 'antd';
import React from 'react';

const locales = ['en', 'fr'];

type LocaleSwitcherProps = {
  value: string;
  onChange: (locale: string) => void;
}

const LocaleSwitcher: React.FC<LocaleSwitcherProps> = props => {
  const {
    value,
    onChange
  } = props;
  const { t } = useI18n();

  const items = locales.map(l => ({
    key: l,
    label: upperFirst(t(`locales.${l}`))
  }))

  return (
    <div>
      <Dropdown
        menu={{ items, onClick: ({ key }) => onChange(key)}}
      >
        <a>
          <Space>
            {t('words.language')}{upperFirst(t(`locales.${value}`))}
            <DownOutlined />
          </Space>
          
        </a>
      </Dropdown>
    </div>
  )
}

export default LocaleSwitcher;